import script from "./checkRules.vue?vue&type=script&lang=ts&setup=true"
export * from "./checkRules.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__